module.exports = {
	"articleTitle1": "Best Burger: Frita Batidos ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Frita Batidos",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/best-burger-frita-batidos",
	"articleSnippet1": "Mar 30, 2017 ... A burger is just a burger, isn't it? Grill up a beef patty, slap it on a bun and top it \nwith lettuce, tomato and onion. Not at Frita Batidos, the ...",
	"articleSnippet2": "Apr 7, 2016 ... For the best burger, one must venture past Main Street and between upscale \nsteakhouses for the quirky and quality favorite — Frita Batidos.",
	"foodRecommendations": [
		{
			"text": "It's a cuban burger place. Anything you get here is great.",
			"person": "Charlie Ruiz"
		},
		{
			"text": "'The Best Snack Ever' may actually be the best snack ever",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Best Burger: Frita Batidos ",
	"address": "117 W Washington St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/eaa.BOAA17.Fritas.2.jpg?itok=fw4aogAF",
			"author": "Evan Aaron",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/eef.FritaBatidosBestofAA.3.27.16.005.jpg?itok=5uoXg9cX",
			"author": "Emilie Farrugia",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.280312,
		"lng": -83.749441
	},
	"totalMisc": 2,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"datespot": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/fritabatidos.json
// module id = 880
// module chunks = 0